import React from 'react';

import styled from '@emotion/styled';

import Header from '@src/components/Base/Header/StandardHeader';
import DefaultHead from '@src/components/Base/Head/DefaultHead';
import MobileSearchbar from '@src/components/Base/Header/MobileSearchbar';
import Footer from '@src/components/Base/Footer/Footer';
import Meta from '@src/components/Base/Head/Meta';
import withoutAuth from '@src/hocs/withoutAuth';
import { useForm } from '@src/hooks/useForm';

import { InputComponent } from '@src/components/User/Login/InputComponent';
import { SocialComponent } from '@src/components/User/Login/SocialComponent';
import { ButtonComponent } from '@src/components/User/Login/ButtonComponent';
import { LinkComponent } from '@src/components/User/Login/LinkComponent';

const Login = () => {
  const { values, bottomText, handleChange, handleLoginSubmit } = useForm({
    initValues: {
      email: '',
      password: '',
      prevUrl: document.referrer,
    },
  });

  return (
    <div>
      <DefaultHead />
      <Meta title={`리걸엔진 | 로그인`} description={`리걸엔진 로그인`} url={`user/login`} />
      <Header imgSrc='/logo.svg' />
      <MobileSearchbar />
      <Container>
        <Article>
          <SocialComponent />
          <Form onSubmit={handleLoginSubmit}>
            <InputComponent values={values} bottomText={bottomText} handleChange={handleChange} />
            <ButtonComponent />
          </Form>
          <LinkComponent />
        </Article>
      </Container>
      <Footer />
    </div>
  );
};

export default withoutAuth(Login);

const Container = styled.main`
  background-color: #e5e5e5;
  margin-top: 65px;
  min-height: calc(100vh - 65px);
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 992px) {
    margin-top: 0;
  }
`;

const Article = styled.section`
  margin: 50px 0;
  padding-bottom: 50px;
  width: 840px;
  height: fit-content;
  background-color: #ffffff;

  @media screen and (max-width: 992px) {
    margin-bottom: 0;
    width: 100%;
  }
`;

const Form = styled.form`
  margin: 0 5.5rem;
  @media screen and (max-width: 992px) {
    margin: 0 2rem;
  }
`;
